enum BiddingTypeEnum {
  Silent = 'silent',
  Live = 'live',
  Sealed = 'sealed',
}

export function isMaxBidAllowed(params: { biddingType: string; unitsAvailable: number }): boolean {
  // not allowed if multiple units available
  if (params.unitsAvailable > 1) return false
  // not allowed for live or sealed bidding items
  if (params.biddingType === BiddingTypeEnum.Live || params.biddingType === BiddingTypeEnum.Sealed) return false
  // allowed otherwise
  return true
}
